export default __webpack_public_path__ + "static/media/breakfast.53395c4a.jpg";